module.exports = __webpack_public_path__ + "static/media/on-air-loop-poster.081aff8a.jpg";